//1.导入VueRouter
// import Vue from "vue";
import VueRouter from 'vue-router'
import index from "../pages/index.vue";
import bene from "../pages/bene.vue";
import peace from "../pages/peace.vue";
import about from "../pages/about.vue";
import contact from "../pages/contact.vue";


//3.创建VueRouter的实例
const router = new VueRouter({
    //tips:不想要 #（锚点）就添加下面代码
     mode: 'history', 
    //4.配置路由的path和组件
    routes :[
        {
          path: "/",
          name:'index',
          component: index,
        },
        {
          path: "/bene",
          name:'bene',
          component: bene,
        },
        {
          path: "/peace",
          name:'peace',
          component: peace,
        },
        {
          path: "/peace.html",
          redirect: "/peace",
        },
        {
          path: "/about",
          name:'about',
          component: about,
        },
        {
          path: "/contact",
          name:'contact',
          component: contact,
        },
      ]
})
//5.导入路由实例
export default router;
